module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.stack) ? _c('div', {
    staticClass: "backdrop",
    attrs: {
      "transition": "modal"
    },
    on: {
      "click": _vm.dismissModal
    }
  }, [_c('form', {
    staticClass: "edit-card-form create edit-stack",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.update($event)
      },
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stack.title),
      expression: "stack.title"
    }],
    staticClass: "form-stack-title",
    attrs: {
      "name": "title",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.stack.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stack.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stack.description),
      expression: "stack.description"
    }],
    staticClass: "stack-why",
    attrs: {
      "name": "description",
      "placeholder": "why learn this?",
      "rows": "2"
    },
    domProps: {
      "value": (_vm.stack.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stack.description = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Done")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0ab48257"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cards/UpdateStackModal.vue
// module id = 190
// module chunks = 1